import React from "react";
import CommonAuthComponent from "./CommonAuthComponent";

export default function SignUpPage() {
    return (
        <CommonAuthComponent variant="signup" />   
    );
}
